<template>
	<div class="report m-3">
		<div class="heading headtext">
			<span>Candidate Report for '{{ candidateDetails.name }}'</span>
		</div>
		<div>
			<b-row class="candidate-details">
				<b-col xl="8" lg="8" sm="12">
					<!--candidate details sections -->
					<b-row class="candidatereport-first-subcontainer">
						<b-col xl="9" lg="9" sm="6" class="ml-3">
							<div class="candidatereport-details">
								<div class="d-flex flex-column mb-2">
									<span class="pd-card-middle-head">Name</span>
									<span class="candidatereport-subheadings">{{
										candidateDetails.name
									}}</span>
								</div>
								<div class="d-flex flex-column mb-2">
									<span class="pd-card-middle-head">Email</span>
									<span class="candidatereport-subheadings">{{
										candidateDetails.emailID
									}}</span>
								</div>
							</div>
							<b-button>
								View Answers
							</b-button>
						</b-col>
						<b-col xl="2" lg="2" sm="6" class="view-answers">
							<img
								src="../../../assets/report_candidate.svg"
								alt="Illustration of a boy sitting"
							/>
						</b-col>
					</b-row>
					<!-- Strength and weeknesses Section -->
					<b-row class="candidatereport-first-subcontainer">
						<b-col>
							<span class="candidatereport-card-header"
								>Candidate strengths and weaknesses</span
							>
							<hr class="w-100" />
							<b-row class="candidate-sw">
								<b-col cols="5" class="bg-card px-0">
									<h6 class="card-header">Strengths</h6>
									<div class="list-container">
										<div
											class="list"
											:style="{
												borderLeft:
													'solid 5px #' +
													Math.random()
														.toString(16)
														.substr(-6),
											}"
										>
											Strength1
										</div>
										<div
											class="list"
											:style="{
												borderLeft:
													'solid 5px #' +
													Math.random()
														.toString(16)
														.substr(-6),
											}"
										>
											Strength1
										</div>
										<div
											class="list"
											:style="{
												borderLeft:
													'solid 5px #' +
													Math.random()
														.toString(16)
														.substr(-6),
											}"
										>
											Strength1
										</div>
										<div
											class="list"
											:style="{
												borderLeft:
													'solid 5px #' +
													Math.random()
														.toString(16)
														.substr(-6),
											}"
										>
											Strength1
										</div>
									</div>
								</b-col>
								<b-col cols="5" class="bg-card px-0">
									<h6 class="card-header">Areas of Development</h6>
									<div class="list-container">
										<div
											class="list"
											:style="{
												borderLeft:
													'solid 5px #' +
													Math.random()
														.toString(16)
														.substr(-6),
											}"
										>
											Aod1
										</div>
										<div
											class="list"
											:style="{
												borderLeft:
													'solid 5px #' +
													Math.random()
														.toString(16)
														.substr(-6),
											}"
										>
											Strength1
										</div>
										<div
											class="list"
											:style="{
												borderLeft:
													'solid 5px #' +
													Math.random()
														.toString(16)
														.substr(-6),
											}"
										>
											Strength1
										</div>
										<div
											class="list"
											:style="{
												borderLeft:
													'solid 5px #' +
													Math.random()
														.toString(16)
														.substr(-6),
											}"
										>
											Strength1
										</div>
									</div>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</b-col>
				<b-col class="candidatereport-first-subcontainer">
					<h4>Overview</h4>
					<OverviewCharts />
				</b-col>
			</b-row>

			<div class="d-flex">
				<!-- Row to display difficulty competency -->
				<div class="report__card bar-chart-container">
					<CompoundBars
						subject="difficulty"
						title="Competence graph (Difficulty)"
					/>
				</div>
				<div class="report__card bar-chart-container">
					<CompoundBars subject="section" title="Competence graph (Sections)" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import OverviewCharts from "./OverviewCharts.vue";
import CompoundBars from "./CompoundBars.vue";
import { getCandidateScoreDetails } from "../../../utils/apiFunctions";
export default {
	name: "CandidatePerformance",

	data() {
		return {
			candidateDetails: {},
		};
	},
	created() {
		this.getData();
	},
	methods: {
		async getData() {
			const { data } = await getCandidateScoreDetails(
				this.$route.params.testID,
				this.$route.params.candidateID
			);
			this.candidateDetails = data.data;

			if (data.type !== "Success") {
				throw new Error("Request Failed");
			} else {
				return data;
			}
		},
	},
	components: {
		OverviewCharts,
		CompoundBars,
	},
};
</script>

<style scoped>
.placeholder {
	height: 200px;
}

.candidate-details {
	display: flex;
	align-items: stretch;
}

.report {
	position: relative;
	padding: 1rem;
	top: 80px;
	padding-left: 80px;
	padding-right: 15px;
	margin-bottom: 10rem;
}

.report__card {
	background: var(--bg-white);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
	margin: 1rem;
	overflow-x: auto;
}

.view-answers {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 1rem 0;
}

.justfy-content-around {
	justify-content: space-between;
}

.gridgreencolorDynamic {
	width: 4px;
	height: 60px;
	border-radius: 2px;
	position: absolute;
	left: -5px;
	top: -8px;
}

.candidatereport-details {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 50%;
	margin-bottom: 1rem;
}

.candidatereport-first-subcontainer {
	background: #ffffff;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
	padding: 20px 10px;
	margin: 10px 0;
}

.candidatereport-first-head {
	font-weight: 500;
	font-size: 14px;
	line-height: 21px;
	color: #72738e;
}

.candidatereport-subheadings {
	font-size: var(--size-13);
	color: var(--bg-tertiary);
}

.candidatereport-second-subcontainer {
	height: 100%;
}
.candidatereports-second-card {
	overflow: auto;
}

.candidatereport-card-header {
	display: block;
	margin: 1rem;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: var(--bg-tertiary);
}

.bg-card {
	background: rgba(255, 255, 255, 0.1);
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
}

.candidate-sw {
	justify-content: space-evenly;
}

.candidate-sw .list-container .list {
	font-size: var(--size-13);
	border: 0.5px solid rgba(114, 115, 142, 0.3);
	border-radius: 1px;
	padding: 15px;
	margin: 10px;
}
</style>
